import {newUTCDate} from './newUTCDate';
import {SaltusAny} from './SaltusAny';

export const getISODateOrUndefined = (value: SaltusAny) => {
  const isValidDate = !Number.isNaN(Date.parse(value));
  if (!isValidDate) {
    return undefined;
  }
  return newUTCDate(value).toISOString();
};

export const getISODateOrEmptyString = (value: SaltusAny) =>
  getISODateOrUndefined(value) || '';
